// V3 (Mirko 15. 9. 2026): tlač priloženého dokladu (PDF alebo fotka) priamo z Matrixu — doklad sa načíta do skrytého
// rámca a otvorí sa tlačový dialóg prehliadača. Keď prehliadač tlač z rámca nedovolí, doklad sa otvorí na novej karte.
const JE_OBRAZOK = /\.(jpe?g|png|webp|gif)$/i

export function tlacitSubor(url) {
  if (!url) return false
  const otvor = () => { try { window.open(url, '_blank', 'noopener') } catch (_) {} }
  try {
    const f = document.createElement('iframe')
    f.setAttribute('aria-hidden', 'true')
    f.setAttribute('tabindex', '-1')
    // mimo obrazovky, ale s rozmermi — prehliadač inak PDF v rámci nemusí vôbec načítať
    f.style.cssText = 'position:fixed;left:-10000px;top:0;width:820px;height:1160px;border:0'
    let hotovo = false
    const uprac = () => setTimeout(() => { try { f.remove() } catch (_) {} }, 60000)
    const tlac = () => {
      if (hotovo) return
      hotovo = true
      try { f.contentWindow.focus(); f.contentWindow.print() } catch (_) { otvor() }
      uprac()
    }
    if (JE_OBRAZOK.test(String(url).split('?')[0])) {
      const esc = String(url).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;')
      f.srcdoc = '<!doctype html><html><head><meta charset="utf-8"><title>Doklad</title><style>@page{margin:10mm}html,body{margin:0}img{display:block;max-width:100%;max-height:270mm;margin:0 auto}</style></head><body><img alt="Doklad" src="' + esc + '"></body></html>'
      f.onload = () => {
        const img = f.contentDocument && f.contentDocument.querySelector('img')
        if (!img || img.complete) { tlac(); return }
        img.onload = tlac
        img.onerror = () => { hotovo = true; otvor(); uprac() }
      }
    } else {
      // PDF: prehliadač potrebuje chvíľu, kým zobrazovač PDF v rámci načíta dokument
      f.onload = () => setTimeout(tlac, 700)
      f.src = url
    }
    document.body.appendChild(f)
    return true
  } catch (_) { otvor(); return false }
}
